"use strict";
/**
 * RadioComponent
 *
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var LabelWithTooltipComponent_1 = __importDefault(require("../MessageComponents/LabelWithTooltipComponent"));
var TooltipComponent_1 = __importDefault(require("../MessageComponents/TooltipComponent"));
var styles_1 = require("@mui/styles");
var configurationTypes_1 = require("../../types/configurationTypes");
var react_redux_1 = require("react-redux");
var crude_selector_1 = require("../../../store/crude/crude.selector");
var useStyles = styles_1.makeStyles(function (theme) { return ({
    flexRow: {
        display: 'flex',
        flexDirection: 'row',
    },
    flexColumn: {
        display: 'flex',
        flexDirection: 'column',
    },
}); });
var RadioComponent = function (props) {
    var _a;
    var classes = useStyles();
    var appLayout = react_redux_1.useSelector(crude_selector_1.getAppLayout);
    var _b = react_1.useState(), value = _b[0], setValue = _b[1];
    var direction = ((_a = appLayout.radio) === null || _a === void 0 ? void 0 : _a.direction) || configurationTypes_1.RadioDirection.row;
    react_1.useEffect(function () {
        props.value && setValue(props.value.key);
    }, [props.value]);
    return (react_1.default.createElement(material_1.FormControl, null,
        react_1.default.createElement(material_1.FormLabel, null,
            react_1.default.createElement(material_1.Typography, { variant: 'body2', style: { display: 'flex' } },
                react_1.default.createElement(LabelWithTooltipComponent_1.default, { label: props.label, description: props.description }))),
        react_1.default.createElement(material_1.RadioGroup, { className: direction === 'row' ? classes.flexRow : classes.flexColumn, name: props.name, value: value, onChange: function (event, newValue) {
                setValue(newValue);
                props.onChange && props.onChange(newValue);
            } }, props.options.map(function (opt) {
            var element = react_1.default.createElement("span", null, opt.value);
            return (react_1.default.createElement(material_1.FormControlLabel, { key: opt.key, value: opt.key, disabled: props.disabled, control: react_1.default.createElement(material_1.Radio, null), checked: value === opt.key, label: react_1.default.createElement(react_1.default.Fragment, null, opt.description
                    ? react_1.default.createElement(TooltipComponent_1.default, { title: opt.description, placement: 'right', element: element })
                    : react_1.default.createElement(react_1.default.Fragment, null, element)) }));
        }))));
};
exports.default = RadioComponent;
